import { t } from "../styles";

/**
 * Pill stepper. A step is clickable once it has been reached and every step
 * before it is valid, so you can jump back freely but not skip ahead past an
 * incomplete step.
 */
const Stepper = ({ steps, current, reached, valid, onGo }) => {
  const firstInvalidBefore = (i) => {
    for (let k = 1; k < i; k++) if (valid[k]) return k;
    return -1;
  };

  return (
    <div style={{ display: "flex", gap: 4, margin: "18px 0 16px", padding: 4, borderRadius: 12, background: "#f4f4f7" }}>
      {steps.map((s, i) => {
        const reachable = i <= reached && firstInvalidBefore(i) === -1;
        const cur = i === current;
        const done = i < current || (i <= reached && !cur && !valid[i]);
        return (
          <button
            key={s.label}
            type="button"
            onClick={() => reachable && onGo(i)}
            style={{
              flex: "1 1 0",
              minWidth: 0,
              display: "flex",
              alignItems: "center",
              gap: 10,
              textAlign: "left",
              font: "inherit",
              padding: "8px 12px",
              border: "none",
              borderRadius: 9,
              background: cur ? "#fff" : "transparent",
              boxShadow: cur ? `0 1px 3px rgba(20,20,32,0.10), 0 0 0 1px ${t.border}` : "none",
              cursor: reachable ? "pointer" : "default",
            }}
          >
            <span
              style={{
                flex: "none",
                width: 22,
                height: 22,
                borderRadius: 6,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 11.5,
                fontWeight: 700,
                background: cur ? t.accent : done ? "#eceafd" : t.border,
                color: cur ? "#fff" : done ? t.accent : t.textMuted,
              }}
            >
              {i + 1}
            </span>
            <span style={{ minWidth: 0, display: "block" }}>
              <span
                style={{
                  display: "block",
                  fontSize: 13,
                  fontWeight: 650,
                  color: cur || done ? t.text : "#6f6f7c",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {s.label}
              </span>
              <span
                style={{
                  display: "block",
                  fontSize: 11.5,
                  color: done && !cur ? t.accent : "#6f6f7c",
                  marginTop: 1,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {s.sub}
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default Stepper;
